import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useSlots, watch } from "vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import RmpText from "@rmp/core/components/typography/RmpText.vue";

interface RmpBtnProps {
	dark?: boolean;
	light?: boolean;
	to?: Object;
	disabled?: boolean;
	outlined?: boolean;
	loading?: boolean;
	color?: string;
	dense?: boolean;
	plain?: boolean;
	block?: boolean;
	text?: boolean;
	elevation?: string | number;
	small?: boolean;
	icon?: boolean | string;
	prependIcon?: string;
	appendIcon?: string;
	iconSize?: string | number;
	/** Replaces the default icon spacing; an empty string removes it. */
	iconClass?: string | Record<string, unknown> | unknown[];
	tooltip?: string;
	withoutPadding?: boolean;
	height?: string | number;
	width?: string | number;
	minWidth?: string | number;
	href?: string;
	padding?: string;
	noMargin?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpBtn',
  props: {
    dark: { type: Boolean, default: false },
    light: { type: Boolean, default: true },
    to: null,
    disabled: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    color: { default: "primary" },
    dense: { type: Boolean, default: false },
    plain: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    text: { type: Boolean, default: false },
    elevation: { default: 0 },
    small: { type: Boolean, default: false },
    icon: { type: [Boolean, String], default: false },
    prependIcon: null,
    appendIcon: null,
    iconSize: { default: 20 },
    iconClass: null,
    tooltip: null,
    withoutPadding: { type: Boolean, default: false },
    height: null,
    width: null,
    minWidth: null,
    href: { default: undefined },
    padding: null,
    noMargin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { dark: boolean, light: boolean, to?: Object, disabled: boolean, outlined: boolean, loading: boolean, color: string, dense: boolean, plain: boolean, block: boolean, text: boolean, elevation: string | number, small: boolean, icon: boolean | string, prependIcon?: string, appendIcon?: string, iconSize: string | number, iconClass?: string | Record<string, unknown> | unknown[], tooltip?: string, withoutPadding: boolean, height?: string | number, width?: string | number, minWidth?: string | number, href: string, padding?: string, noMargin?: boolean };

const slots = useSlots();
const button = ref<{ $el: HTMLElement } | null>(null);
const tooltipVisible = ref(false);



watch(() => props.disabled || props.loading || !props.tooltip, unavailable => {
	if(unavailable) tooltipVisible.value = false;
});

const buttonHeight = computed(() => props.height ?? (props.icon ? "auto" : 40));

const buttonPadding = computed(() => {
	return props.padding ?? (slots.prepend || props.prependIcon ? "pr-4 pl-3" : "px-4");
});

const svgIconSize = computed(() => Number.isNaN(Number(props.iconSize)) ? props.iconSize : `${Number(props.iconSize)}px`);

const iconComponent = (name: string) => name.startsWith("mdi-") ? "v-icon" : RmpIcon;
const iconProps = (name: string) => name.startsWith("mdi-")
	? { size: props.iconSize }
	: { src: name, size: svgIconSize.value, color: "inherit" };
const iconText = (name: string) => name.startsWith("mdi-") ? name : "";

return { __sfc: true,slots, button, tooltipVisible, props, buttonHeight, buttonPadding, svgIconSize, iconComponent, iconProps, iconText, RmpText }
}

})